import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getVersionString } from '../utils/version';

const Footer = () => {
  const versionString = getVersionString();
  const navigate = useNavigate();

  const linkStyle = {
    color: '#fff',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 8px',
    borderRadius: '4px',
    opacity: 0.92,
    transition: 'opacity 140ms ease, background-color 140ms ease',
    fontFamily: 'inherit',
    fontSize: '12px',
    cursor: 'pointer',
    background: 'transparent',
    border: 'none',
  };

  const onEnter = (e) => {
    e.currentTarget.style.opacity = 1;
    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.12)';
  };
  const onLeave = (e) => {
    e.currentTarget.style.opacity = 0.92;
    e.currentTarget.style.backgroundColor = 'transparent';
  };

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #7A9A01 0%, #8AAE02 100%)',
        padding: '10px 20px',
        color: '#fff',
        fontSize: '12px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        // Ohne border-box addiert sich das horizontale Padding auf die 100%
        // Breite und erzeugt einen horizontalen Scrollbalken.
        boxSizing: 'border-box',
        boxShadow: '0 -1px 3px rgba(0, 0, 0, 0.1)',
        fontWeight: 500,
        letterSpacing: '0.01em',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', opacity: 0.95 }}>
        <span>
          Entwickelt von Marvin Hackfort für die Katholische Hochschule
          Nordrhein-Westfalen
        </span>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          opacity: 0.85,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        <span>v{versionString}</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <button
          type="button"
          onClick={() => navigate('/lizenzen')}
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
          style={linkStyle}
        >
          Lizenzen
        </button>
        <a
          href="https://katho-nrw.de/impressum"
          target="_blank"
          rel="noopener noreferrer"
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
          style={linkStyle}
        >
          Impressum
          <span style={{ fontSize: '10px', opacity: 0.8 }}>↗</span>
        </a>
        <a
          href="https://katho-nrw.de/datenschutz"
          target="_blank"
          rel="noopener noreferrer"
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
          style={linkStyle}
        >
          Datenschutz
          <span style={{ fontSize: '10px', opacity: 0.8 }}>↗</span>
        </a>
      </div>
    </div>
  );
};

export default Footer;
